export enum EGymAssessmentMode {
  FixedQuestions = 'FixedQuestions',
  Timed = 'Timed',
}
